export default __webpack_public_path__ + "static/windsstudio_background-ba02cc00ed5e6b91a51ec268b90f58ac.webp";